export default "/images/plaid-logo.png?0d611e4a81ba282278a5b556d5893bc0";